import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MobileStickyBar = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-100 px-4 py-3 flex gap-3">
      <a
        href="tel:+17026042093"
        className="flex-1 flex items-center justify-center gap-2 bg-black text-white text-sm font-semibold py-3.5 rounded-xl whitespace-nowrap cursor-pointer active:bg-gray-800 transition-colors"
      >
        <i className="ri-phone-fill text-base"></i>
        {t('callNow')}
      </a>
      <Link
        to="/services"
        className="flex-1 flex items-center justify-center gap-2 border-2 border-black text-black text-sm font-semibold py-3.5 rounded-xl whitespace-nowrap cursor-pointer active:bg-gray-50 transition-colors"
      >
        <i className="ri-file-list-3-line text-base"></i>
        {t('getFreeQuote')}
      </Link>
    </div>
  );
};

export default MobileStickyBar;
